'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { trackPageView } from '@/lib/analytics';
import { registerDevice } from '@/actions/user_specific';

/**
 * Tracker Component
 * This client component listens for route changes in Next.js
 * and triggers a Comscore pageview event for each change.
 * It leverages the usePathname and useSearchParams hooks to get the current URL.
 */
export default function Tracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    registerDevice();
  }, []);

  useEffect(() => {
    // Construct the full URL for tracking
    const url = `${window.location.origin}${pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;
    const title = document.title; // Get the current page title

    // Track the page view using the helper function
    trackPageView(url, title);

    // This effect runs whenever the pathname or searchParams change,
    // effectively tracking every client-side navigation.
  }, [pathname, searchParams]);

  return null; // This component does not render any UI
}
